import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Button } from 'semantic-ui-react';
import axios from '../../../util/CustomAxios';
import {
  getFormValues,
  getFormSyncErrors,
  touch,
  stopSubmit,
} from 'redux-form';
import { Link, Redirect } from 'react-router-dom';

import { BallLoader } from '../../General/BallLoader';
import '../SalesOrder.css';
import { resolveRate } from '../presenters/setRate';
import { roundForDatabase, roundCurrency } from '../../../util/currency';

class ButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      createdSOID: -1,
      isLoading: false,
    };
    this.submitButtonOnClickHandler =
      this.submitButtonOnClickHandler.bind(this);
  }
  submitButtonOnClickHandler(event, data) {
    const currentValues = this.props.SalesOrderFormData || {};

    // Manual validation function
    const manualValidate = (values) => {
      const errors = {};

      if (!values.SOIssueDate) {
        errors.SOIssueDate = 'Required';
      }
      if (!values.SOType) {
        errors.SOType = 'Required';
      }
      if (!values.billingAccountID) {
        errors.billingAccountID = 'Required';
      }
      if (!values.shippingAccountID) {
        errors.shippingAccountID = 'Required';
      }
      if (!values.bill_to) {
        errors.bill_to = 'Required';
      }
      if (!values.ship_to) {
        errors.ship_to = 'Required';
      }
      if (!values.TermsOfDelivery) {
        errors.TermsOfDelivery = 'Required';
      }
      if (!values.DeliveryMethod) {
        errors.DeliveryMethod = 'Required';
      }

      return errors;
    };

    const manualErrors = manualValidate(currentValues);

    // Force touch all fields to trigger validation UI FIRST
    const fieldsToTouch = [
      'SOIssueDate',
      'SOType',
      'billingAccountID',
      'shippingAccountID',
      'bill_to',
      'ship_to',
      'TermsOfDelivery',
      'DeliveryMethod',
    ];

    this.props.dispatch(touch('SalesOrder', ...fieldsToTouch));

    // If there are form field validation errors, show them and stop submit
    if (Object.keys(manualErrors).length > 0) {
      this.props.dispatch(stopSubmit('SalesOrder', manualErrors));
      return;
    }

    // Only check product list if all form fields are valid
    if (
      !this.props.productOrderList ||
      this.props.productOrderList.length === 0
    ) {
      alert('Please add at least one product to the order');
      return;
    }

    // Continue with submit logic if validation passes
    this.continueSubmit();
  }

  continueSubmit() {
    // if it is dropship, check if the note is empty
    if (
      !!this.props.SalesOrderFormData.DropShip &&
      !this.props.SalesOrderFormData.Note
    ) {
      alert('Note is required when DropShip is checked');
      return;
    }

    const currency = this.props.currency.trim();
    const rawAmount =
      this.props.salesOrderType === 8
        ? -Math.abs(
            Number(this.props.subTotal) +
              Number(this.props.SalesOrderFormData.ShippingCharge) +
              Number(this.props.SalesOrderFormData.Adjustment)
          )
        : Number(this.props.subTotal) +
          Number(this.props.SalesOrderFormData.ShippingCharge) +
          Number(this.props.SalesOrderFormData.Adjustment);

    const SalesOrderData = {
      ...this.props.SalesOrderFormData,
      AccountID: this.props.SalesOrderFormData.billingAccountID,
      Status: 4,
      Payment: null,
      DateofShipment: null,
      DateofPickUp: null,
      Currency: currency,
      // 총액은 통화 정밀도(KRW 정수 / USD 2자리)로 저장해 소수점 잔여값을 막는다.
      Amount: roundCurrency(rawAmount, currency),
      ShippingCharge: roundForDatabase(
        this.props.SalesOrderFormData.ShippingCharge || 0,
        currency
      ),
      Adjustment: roundForDatabase(
        this.props.SalesOrderFormData.Adjustment || 0,
        currency
      ),
      Company: this.props.company,
      SODetailes: this.props.SODetailes.map((detail) => ({
        ...detail,
        Amount: roundCurrency(detail.Amount, detail.Currency || currency),
        Discount: parseFloat(Number(detail.Discount || 0).toFixed(4)),
        Rate: roundForDatabase(detail.Rate, detail.Currency || currency),
      })),
      DropShipContactId: this.props.SalesOrderFormData.DropShipContactId,
    };

    this.setState({
      isLoading: true,
    });

    if (this.props.isEdit) {
      console.log(`Making PUT request to /SalesOrder/${this.props.SOID}`);
      console.log('Request payload:', JSON.stringify(SalesOrderData, null, 2));
      axios
        .put(`/SalesOrder/${this.props.SOID}`, SalesOrderData)
        .then((response) => {
          console.log('PUT request successful:', response);
          this.setState({
            isSubmited: true,
            createdSOID: this.props.SOID,
          });
        })
        .catch((error) => {
          console.log('PUT request failed:', error);
          console.log('Error details:', error.response?.data);
          this.setState({
            isLoading: false,
          });
          alert('에러가 발생했습니다. 담당자에게 문의해주세요.');
        });
    } else {
      console.log('SalesOrderData', SalesOrderData);
      axios
        .post('/SalesOrder/', SalesOrderData)
        .then(async (response) => {
          this.setState({
            isSubmited: true,
            createdSOID: response.data.SOID,
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          alert('에러가 발생했습니다. 담당자에게 문의해주세요.');
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <BallLoader /> : null}
        {this.state.isSubmited ? (
          <Redirect to={`/SalesOrder/${this.state.createdSOID}`} />
        ) : null}
        <Grid.Row stretched style={this.props.style}>
          <Grid.Column width={10} verticalAlign="middle"></Grid.Column>
          <Grid.Column width={3} verticalAlign="middle">
            <Link
              to={
                this.props.isEdit
                  ? `/SalesOrder/${this.props.SOID}`
                  : '/SalesOrder'
              }
            >
              <Button size="big" className="CancelButton">
                Cancel
              </Button>
            </Link>
          </Grid.Column>
          <Grid.Column width={3} verticalAlign="middle">
            {/* <button type="submit">Submit</button> */}
            <button
              class="big ui button"
              type="submit"
              onClick={this.submitButtonOnClickHandler}
              disabled={this.state.isSubmited || this.state.isLoading}
            >
              {this.props.isEdit ? 'Save' : 'Submit'}
            </button>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    currency: !!state.selectedCustomer.billingCustomer.Currency
      ? state.selectedCustomer.billingCustomer.Currency.trim()
      : 'USD',
    selectedCustomer: state.selectedCustomer.billingCustomer,
    productOrderList: state.productOrderList,
    subTotal: state.productOrderList.reduce((a, b) => {
      const salesOrderType = state.SalesOrderFormData?.SOType;
      const quantity =
        salesOrderType === 8 ? -Math.abs(b.quantity) : b.quantity;

      const itemAmount =
        b.amount != null
          ? salesOrderType === 8
            ? -Math.abs(b.amount)
            : b.amount
          : (() => {
              const rate = resolveRate(
                b,
                state.selectedCustomer.billingCustomer.Currency,
                state.company,
                state.billingCountry
              );
              return (
                rate * Number(quantity) * ((100 - Number(b.discount)) / 100)
              );
            })();

      return a + itemAmount;
    }, 0),
    SalesOrderFormData: !!getFormValues('SalesOrder')(state)
      ? getFormValues('SalesOrder')(state)
      : null,
    SalesOrderFormDataError: getFormSyncErrors('SalesOrder')(state),
    SODetailes: state.productOrderList.map((productOrder, index) => {
      try {
        const salesOrderType = state.SalesOrderFormData?.SOType;
        const quantity =
          salesOrderType === 8
            ? -Math.abs(productOrder.quantity)
            : productOrder.quantity;

        const rate = resolveRate(
          productOrder,
          state.selectedCustomer.billingCustomer.Currency,
          state.company,
          state.billingCountry
        );

        const amount =
          productOrder.amount != null
            ? salesOrderType === 8
              ? -Math.abs(productOrder.amount)
              : productOrder.amount
            : rate *
              Number(quantity) *
              ((100 - Number(productOrder.discount)) / 100);

        const result = {
          ProductID:
            productOrder.product.ProductID || productOrder.product.ProductId,
          Model: productOrder.product.Model || productOrder.product.Model,
          ProductCode:
            productOrder.product.ProductCode ||
            productOrder.product.ProductCode,
          Color: productOrder.product.Color || productOrder.product.Color,
          Currency:
            state.selectedCustomer.billingCustomer.Currency == undefined
              ? 'USD'
              : state.selectedCustomer.billingCustomer.Currency.trim(),
          Rate: rate,
          Quantity: quantity,
          Discount: productOrder.discount,
          Amount: amount,
          IsCustomDiscount: productOrder.isCustomDiscount,
          Serial: null,
          SOIID: productOrder.SOIID,
          customDescription: productOrder.customDescription,
        };

        return result;
      } catch (error) {
        console.error(`Error mapping productOrder ${index}:`, error);
        return {
          ProductID: null,
          Model: null,
          ProductCode: null,
          Color: null,
          Currency: 'USD',
          Rate: 0,
          Quantity: 0,
          Discount: 0,
          Amount: 0,
          IsCustomDiscount: false,
          Serial: null,
          SOIID: productOrder.SOIID,
          customDescription: null,
        };
      }
    }),
    shippingCustomerID: state.shippingCustomerID,
    company: state.company,
    salesOrderType: getFormValues('SalesOrder')(state)?.SOType,
  }),
  null,
  null,
  { withRef: true }
)(ButtonContainer);
